/**
 * @module Shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// getElementsByTagName is returning any type. Disabling tslint conf for that
/* tslint:disable:no-any */
import { AfterViewInit, Directive, OnDestroy, Input, ElementRef, OnChanges } from '@angular/core';
import { SimpleChanges } from '@angular/core';

@Directive({
  selector: '[tmoRemoveRoleTab]',
})
export class RemoveRoleTabDirective implements OnDestroy, OnChanges, AfterViewInit {
  /**
   * ariaLabel variable to get aria-label
   */
  @Input() public ariaLabel: string = '';
  /**
   * anchorTag variable to store anchor element ref
   */
  private anchorTag: any;

  constructor(private elRef: ElementRef) {}

  /**
   * Method to run after view rendered so that it can capture prime-ng elements
   * @return void
   */
  public ngAfterViewInit(): void {
    const tabEl = this.elRef.nativeElement;
    if (tabEl.nodeName === 'P-ACCORDIONTAB') {
      this.anchorTag = tabEl.getElementsByTagName('a')[0];
      this.anchorTag.removeAttribute('role');
      this.anchorTag.setAttribute('aria-label', this.ariaLabel + ' blade');
    }
  }

  /**
   * Method to update aria-label if value get changes
   * @param changes to get previous and current values
   * @return void
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.ariaLabel &&
      changes.ariaLabel.previousValue !== changes.ariaLabel.currentValue &&
      this.anchorTag
    ) {
      this.anchorTag.setAttribute('aria-label', changes.ariaLabel.currentValue.concat(' tab'));
    }
  }

  /**
   * ngOnDestroy method
   * @return void
   */
  public ngOnDestroy(): void {}
}
